export default __webpack_public_path__ + "static/media/arrows.cc24e76e.svg";